import Hero from "../components/Hero";
import AboutPage from "./AboutPage";
import Marquee from "../components/Marquee";
import Work from "../components/Work";
import OurServices from "../components/OurServices";
import Process from "../components/Process";
import Partners from "../components/Partners";
import CertificationsMarquee from "../components/CertificationsMarquee";
import BlogPage from "../pages/BlogPage";
import CTA from "../components/CTA";

interface HomeProps {
  setIsContactModalOpen?: (open: boolean) => void;
}

export default function Home({ setIsContactModalOpen }: HomeProps) {
  return (
    <main className="overflow-x-hidden">
      {/* 01. Hero Section */}
      <section className="relative">
        <Hero setIsContactModalOpen={setIsContactModalOpen} />
      </section>

      {/* 02. Brand Marquee */}
      <section className="relative">
        <Marquee />
      </section>

      {/* 03. About Section */}
      <section className="relative">
        <AboutPage />
      </section>

      {/* 04. Services Section */}
      <section className="relative">
        <OurServices />
      </section>

      {/* 05. Accreditations & Recognitions Marquee */}
      <section className="relative pt-10 pb-4">
        <CertificationsMarquee />
      </section>

      {/* 06. Partners Section */}
      <section className="relative py-16 lg:py-24">
        <Partners />
      </section>

      {/* 07. Work Section */}
      <section className="relative">
        <Work />
      </section>

      {/* 08. Process Section */}
      <section className="relative pt-16 lg:pt-24">
        <Process />
      </section>

      {/* 09. Blog Section */}
      <section className="relative pt-16 lg:pt-24">
        <BlogPage />
      </section>

      {/* 10. CTA Section */}
      <section className="relative pt-16 lg:pt-24 pb-24 lg:pb-40">
        <CTA setIsContactModalOpen={setIsContactModalOpen} />
      </section>
    </main>
  );
}
